export const isValidCurrency = (currency?: string): boolean => {
    try {
        if (!currency) {
            return false;
        }
        new Intl.NumberFormat('en', {
            style: 'currency',
            currency: currency,
        });
        return true;
    } catch {
        return false;
    }
};
